/**
 * 按当前商品配置顺序获取已发布协议，不回退到官网全局配置。
 * @param {object|null} product 当前商品及其协议配置
 * @returns {Array<object>} 可展示的协议，确认标识绑定商品与版本
 */
export function getProductAgreements(product) {
  const keys = Array.isArray(product?.agreementKeys) ? product.agreementKeys : []
  const published = Array.isArray(product?.agreements) ? product.agreements : []
  return [...new Set(keys)].flatMap(key => {
    const matches = published.filter(item => item?.key === key)
    if (matches.length !== 1) return []
    const agreement = matches[0]
    if (!String(agreement.title || '').trim() || !String(agreement.content || '').trim()
      || !Number.isInteger(agreement.version) || !/^[a-f0-9]{64}$/.test(agreement.contentHash || '')) return []
    return [{
      ...agreement,
      confirmationKey: JSON.stringify([product.productCode, key, agreement.version, agreement.contentHash])
    }]
  })
}

/**
 * 确保商品要求的协议全部可用，避免只展示部分已发布协议便放行下单。
 * @param {object|null} product 当前商品
 * @param {Array<object>} agreements 实际可展示的协议
 * @returns {boolean} 至少配置一份且全部可用
 */
export function hasCompleteProductAgreements(product, agreements) {
  const keys = Array.isArray(product?.agreementKeys) ? product.agreementKeys : []
  return keys.length > 0 && new Set(keys).size === keys.length
    && agreements.length === keys.length
    && keys.every(key => agreements.some(agreement => agreement.key === key))
}

/**
 * 构造用户实际勾选的协议版本列表，由后端再次核对商品配置。
 * @param {Array<object>} agreements 当前商品可展示的协议
 * @param {string[]} acceptedKeys 用户勾选的商品/协议/版本标识
 * @returns {Array<{key: string, version: number, contentHash: string}>} 下单确认列表，含实际阅读内容指纹
 */
export function buildAcceptedAgreements(agreements, acceptedKeys) {
  return agreements.filter(agreement => acceptedKeys.includes(agreement.confirmationKey))
    .map(({ key, version, contentHash }) => ({ key, version, contentHash }))
}
